define([
	"dojo/_base/declare",
	"csi/table/New",
	"csi/xml"
], function(declare,New,xml) {

	return declare(New, {
		_canNavigate: function() {
			// summary: restrict Save&Go here
			return false;
		},

		_onAction: function() {
			// summary: create DSLineItem to wrap new node
			var	typeNode = this.widget.relRoot.getTargetClass().getType();
			var urlItem = this.m_urlNode;

			this.m_urlNode = this.createNewUrl();

			this.m_cnNew = this.m_writer.createNode(this.m_urlNode, typeNode)
				.changeAttribute("Copy", xml.ATTR_REF, urlItem)
				.changeAttribute("Actual", xml.ATTR_REF, urlItem);
		}
	});
});